import type { IValidatedResponse } from '../../../httpClient';
import { getRequest } from '../../../httpClient';
import type { IListTransactionsResponse } from '../listTransactions/list-transactions-response';
import { listTransactionsResponseSchema } from '../listTransactions/list-transactions-response';

export async function listUserTransactionsApi(
  userId: string,
): Promise<IValidatedResponse<IListTransactionsResponse>> {
  return getRequest<IListTransactionsResponse>({
    path: `/sys/billing/users/${userId}/transactions`,
    schema: listTransactionsResponseSchema,
  });
}
